import {
  arrayUnion,
  doc,
  getDoc,
  getFirestore,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { DB_NODES } from "../../../../db/constants/nodeNames";
import { AppNotificationType } from "../../models/Notification/Notification";

export interface ReceivedPushNotificationPayload {
  notification: { body: string };
  data: { type: AppNotificationType };
}

async function fetchPushNotificationTokens(userId: string): Promise<string[]> {
  const db = getFirestore();
  const document = doc(db, DB_NODES.PUSH_NOTIFICATION_TOKENS, userId);
  await getDoc(document);
  const docSnap = await getDoc(document);

  if (!docSnap.exists()) {
    return [];
  }

  const data = docSnap.data() as { tokens: string[] };
  return data.tokens;
}

async function getPushNotificationToken(): Promise<string | undefined> {
  const messaging = getMessaging();
  let token: string | undefined;

  try {
    token = await getToken(messaging, {
      vapidKey:
        "BE4H_xE-8X6AYsorNjluYip5wivebgOlDsZzPE8DYJlDxdet7lVQwU_0VrgONImcGIPQTAULeDN4C-INNx2kvaI",
    });
  } catch (e) {
    console.error(e);
  }

  return token;
}

async function savePushNotificationToken({
  userId,
  token,
}: {
  userId: string;
  token: string;
}) {
  const db = getFirestore();
  const document = doc(db, DB_NODES.PUSH_NOTIFICATION_TOKENS, userId);
  await getDoc(document);
  const docSnap = await getDoc(document);

  if (docSnap.exists()) {
    await updateDoc(document, {
      [DB_NODES.TOKENS]: arrayUnion(token),
    });
    return;
  }

  await setDoc(document, { [DB_NODES.TOKENS]: [token] }, { merge: true });
}

function onMessageListener() {
  const messaging = getMessaging();
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
}

function isSupported() {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
}

const pushNotificationsService = {
  fetchPushNotificationTokens,
  getPushNotificationToken,
  isSupported,
  savePushNotificationToken,
  onMessageListener,
};

export default pushNotificationsService;
